require('./brokerConvenienceMiFIDTestWizard.overrde.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');

// @commons
const Wizard = require('components/commons/wizard/wizard');

// @components
const { BrokerConvenienceMiFIDTestStep0 } = require('mifid/components/brokerConvenienceMiFIDTestWizard/brokerConvenienceMiFIDTestStep0/brokerConvenienceMiFIDTestStep0');
const { BrokerConvenienceMiFIDTestStep1 } = require('mifid/components/brokerConvenienceMiFIDTestWizard/brokerConvenienceMiFIDTestStep1/brokerConvenienceMiFIDTestStep1');
const { BrokerConvenienceMiFIDTestStep2 } = require('mifid/components/brokerConvenienceMiFIDTestWizard/brokerConvenienceMiFIDTestStep2/brokerConvenienceMiFIDTestStep2');
const { BrokerConvenienceMiFIDTestStep3 } = require('mifid/components/brokerConvenienceMiFIDTestWizard/brokerConvenienceMiFIDTestStep3/brokerConvenienceMiFIDTestStep3');
const { BrokerConvenienceMiFIDTestStep4 } = require('mifid/components/brokerConvenienceMiFIDTestWizard/brokerConvenienceMiFIDTestStep4/brokerConvenienceMiFIDTestStep4');

// @helpers
const { isRenderStep0 } = require('mifid/utilities/mifidValidHelper');

const BrokerConvenienceMiFIDTestWizard = props => {
    const { immSteps, actions, visibleStep, isConsulting, onOmitTest } = props;
    let className;
    const renderStep0 = isRenderStep0() && !isConsulting;
    let steps = [];

    if (renderStep0) {
        steps.push(
            <BrokerConvenienceMiFIDTestStep0
                actions={actions}
                isConsulting={isConsulting}
            />
        );
    }

    steps.push(
        <BrokerConvenienceMiFIDTestStep1
            actions={actions}
            isConsulting={isConsulting}
            onOmitTest={onOmitTest}
            renderStep0={renderStep0}
        />,
        <BrokerConvenienceMiFIDTestStep2
            actions={actions}
            isConsulting={isConsulting}
            renderStep0={renderStep0}
        />,
        <BrokerConvenienceMiFIDTestStep3
            actions={actions}
            isConsulting={isConsulting}
            renderStep0={renderStep0}
        />
    );

    if (isConsulting) {
        className = "broker-convenience-mifid-test-wizard";
    } else {
        steps.push(<BrokerConvenienceMiFIDTestStep4 actions={actions}/>);
    }
    const stepsAmount = immSteps.size;
    return (
        <Wizard
            wizardClass={className}
            actions={actions}
            immSteps={immSteps}
            stepsAmount={stepsAmount}
            visibleStep={visibleStep}
        >
            {steps}
        </Wizard>
    );
};

BrokerConvenienceMiFIDTestWizard.propTypes = {
    visibleStep: PropTypes.number.isRequired,
    immSteps: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    isConsulting: PropTypes.bool.isRequired,
    onOmitTest: PropTypes.func.isRequired
}

module.exports = BrokerConvenienceMiFIDTestWizard;